export function bufferToUrlEncodedB64(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer);
  let binary = '';
  for (let i = 0; i < bytes.byteLength; i += 512) {
    binary += String.fromCharCode(...bytes.slice(i, i + 512));
  }
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}

export function urlEncodedB64ToBuffer(urlEncodedBase64String: string): BufferSource {
  let str = urlEncodedBase64String.trim().replace(/-/g, '+').replace(/_/g, '/');

  const padLength = (4 - (str.length % 4)) % 4;
  str += '='.repeat(padLength);

  const binaryString = atob(str);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  return bytes;
}

export function isResponse(value: unknown): value is Response {
  if (isBoolean(value)) {
    return false;
  }
  const obj = (value as object);
  return 'headers' in obj
    && 'ok' in obj
    && 'status' in obj
    && 'body' in obj;
}

export function isError(value: unknown): value is Error {
  if (isBoolean(value)) {
    return false;
  }
  const obj = (value as object);
  return 'name' in obj
    && 'message' in obj
    && 'stack' in obj;
}

export function isBoolean(value: unknown): value is boolean {
  return typeof value === 'boolean';
}
